import { CircleIcon, SquareRoundedIcon, TriangleRoundedIcon } from "../../assets/icons";

export enum TableShapeType {
    Round,
    Square,
    Rectangle,
    Triangle
}

export function tableShapeToIcon(shape: TableShapeType): string {
    switch (shape) {
        case TableShapeType.Round:
            return CircleIcon;
        case TableShapeType.Square:
            return SquareRoundedIcon;
        case TableShapeType.Rectangle:
            return SquareRoundedIcon;
        case TableShapeType.Triangle:
            return TriangleRoundedIcon;
        default:
            return SquareRoundedIcon;
    }
}
